import * as React from "react";

export type CardProps = React.HTMLAttributes<HTMLDivElement>;

export const Card = React.forwardRef<HTMLDivElement, CardProps>(({ className = "", ...props }, ref) => {
  const base =
    "rounded-3xl border border-neutral-200 bg-white p-6 shadow-sm transition";
  return <div ref={ref} className={`${base} ${className}`} {...props} />;
});

Card.displayName = "Card";
